module.exports = __webpack_public_path__ + "static/demo-4c495019c75dd8c78ad7c97be064c94f.gif";